import { CondResult, TourCondition, TourContext } from '../types';

/**
 * Name -> predicate registry. The core knows only the indirection; the predicates themselves
 * are registered by whoever owns the domain (see config/habitat/conditions.ts), so nothing in
 * this module has to learn what a camera or a schedule is.
 *
 * Registering is idempotent by name — a re-import must not double-register or throw.
 */
const CONDITIONS = new Map<string, TourCondition>();

export const registerConditions = (conditions: Record<string, TourCondition>): void => {
  Object.entries(conditions).forEach(([name, predicate]) => CONDITIONS.set(name, predicate));
};

/**
 * Evaluate a named condition. An unknown name answers `false`, not `pending`: `pending` means
 * "ask again once the data lands", and a missing predicate never lands. Answering `pending`
 * would hang the step forever on what is really an authoring typo.
 */
export const evaluateCond = (name: string | undefined, ctx: TourContext | undefined): CondResult => {
  if (!name) return true; // ungated
  const predicate = CONDITIONS.get(name);
  if (!predicate) return false;
  return predicate(ctx);
};

/** Test seam + validation: which names are currently registered. */
export const registeredConditionNames = (): string[] => [...CONDITIONS.keys()];
